export default __webpack_public_path__ + "static/media/AIRPORT.28a58a0d.png";